// extracted by mini-css-extract-plugin
export default {"link":"gXpPZ"};